import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import { ReservesRetainedService } from './reserves-retained.service';
import * as CryptoJS from 'crypto-js';
import { IncomeStatementService } from '../../income-statement/income-statement.service';
import { FinancialpositionService } from '../../financialposition/financialposition.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { SideNavService } from '../../../../theme/layout/admin/navigation/service/side-nav.service';

@Component({
  selector: 'app-reserves-retained-profit',
  templateUrl: './reserves-retained-profit.component.html',
  styleUrls: ['./reserves-retained-profit.component.scss']
})
export class ReservesRetainedProfitComponent implements OnInit {
  profitform: FormGroup;
  APPeriodId: any; isJump: any;
  incomestatementdata: any
  profitloss: any
  Dividends: any
  reserveddata: any
  reservedvalue: any
  NormalRoutng: boolean;
  showBubbledata:any
  constructor(private formbuilder: FormBuilder, public commonService: CommonService, private router: Router, private reserveservice: ReservesRetainedService,
    private incomeStatementService: IncomeStatementService, private balanceSheetService: FinancialpositionService, public sidenav: SideNavService) { }
  ngOnInit() {
    debugger;
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.getIncomeStatementData()
    this.getBalanceSheetData(this.APPeriodId)
    
    this.createprofit();
    this.isJump = localStorage.getItem('isJump')
    //this.commonService.Showbubble.subscribe((data) => {
    //  if (data) {
        this.commonService.getImportPageSelectionData(this.commonService.AccountTemplateId, CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8), this.APPeriodId).subscribe((data) => {
          this.commonService.showBubble = data[0].ImportStatus
          if (this.commonService.showBubble) {
            this.sidenav.setShowBubble(true)
            this.getlastyearprofit();
          }
        })
    //  }
    //  else {
    //    this.showBubbledata = null
    //  }
    //})
      this.clearfield();
    if (localStorage.getItem("SubmitStatus") == "true")
      this.profitform.disable()
  
    }

  createprofit() {
    this.profitform = this.formbuilder.group({
      ReservesRetainedProfitId: new FormControl(),
      APPeriodId: new FormControl(),
      ReservesAsAt: new FormControl(),
      ProfitForYear: new FormControl(),
      EquityDividendsPaid: new FormControl({value:'',disabled:true}),
      RetainedProfitAt: new FormControl(),
      AdditionalInformation: new FormControl(),
      CreatedBy: new FormControl(),
    })
  }

  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.profitform.reset()
      }
    })
  }

  save(){
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.profitform.controls['APPeriodId'].setValue(this.APPeriodId);
    this.profitform.controls['CreatedBy'].setValue(localStorage.getItem('LoginuserId'));
    const formdata = this.profitform.getRawValue();
    

    //if (this.profitform.controls['ReservesAsAt'].value == "" || this.profitform.controls['ReservesAsAt'].value == null || this.profitform.controls['ReservesAsAt'].value=="0") {
    //  this.reserveservice.insertprofit(formdata).subscribe((data) => {
    //    this.profitform.markAsPristine();
    //    if (this.count == 2) {
    //      this.commonService.DisplayAccountingPeriodlist = true;
    //      this.router.navigate(['/business']);
    //    }
    //    if (this.NormalRoutng)
    //      return true;
    //    var nextPage;
    //    nextPage = this.commonService.getNextNoteSelection("Reserves / Retained profit", this.commonService.NotesList)
    //    if (this.isJump == 'true')
    //      this.router.navigate(['/notes'])
    //    else if (nextPage == 'reserves/retainedprofit') {
    //      nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
    //      this.router.navigate([nextPage]);
    //    }
    //    else {
    //      this.router.navigate([nextPage]);
    //    }
    //  })
    //} else
    if (this.profitform.controls['RetainedProfitAt'].value != this.reservedvalue) {
      let message = ''
      if (this.commonService.AccountTemplateId == 8 && this.commonService.AccountTypeId == 2) {
        message = "Retained profits at " + this.commonService.EndDate + " must tally with the Capital and Reserves - Profit and Loss account value in the Trial balance for the year " + this.commonService.StartYear + "."
      } else {
        message = "Retained profits at " + this.commonService.EndDate + " must tally with the Capital and Reserves - Profit and Loss account value in the Balance Sheet for the year " + this.commonService.StartYear + "."

      }
      Swal.fire({
        title: "Andica Accounts Production",
        text: message,
        icon: "warning",
        confirmButtonText: "OK",
      }).then((result) => {
        this.reserveservice.insertprofit(formdata).subscribe((data) => {
          this.profitform.markAsPristine();
          if (this.count == 2) {
            this.commonService.DisplayAccountingPeriodlist = true;
            this.router.navigate(['/business']);
          }
          if (this.NormalRoutng)
            return true;
          var nextPage;
          nextPage = this.commonService.getNextNoteSelection("Reserves / Retained profit", this.commonService.NotesList)
          if (this.isJump == 'true')
            this.router.navigate(['/notes'])
          else if (nextPage == 'reserves/retainedprofit') {
            nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
            this.router.navigate([nextPage]);
          }
          else {
            this.router.navigate([nextPage]);
          }
        })
      })
    }
    else {
      this.reserveservice.insertprofit(formdata).subscribe((data) => {
        this.profitform.markAsPristine();
        if (this.count == 2) {
          this.commonService.DisplayAccountingPeriodlist = true;
          this.router.navigate(['/business']);
        }
        if (this.NormalRoutng)
          return true;
        var nextPage;
        nextPage = this.commonService.getNextNoteSelection("Reserves / Retained profit", this.commonService.NotesList)
        if (this.isJump == 'true')
          this.router.navigate(['/notes'])
        else if (nextPage == 'reserves/retainedprofit') {
          nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
          this.router.navigate([nextPage]);
        }
        else {
          this.router.navigate([nextPage]);
        }
      })
    }
    //else {
    //  //this.NormalRoutng = false;
    //  this.insertprofit();
    //  return false;
    //}
    return false;
  }

  getIncomeStatementData() {
    debugger
    var APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.incomeStatementService.getIncomeStatement(APPeriodId).subscribe((data:any) => {
      this.incomestatementdata = data
      //this.profitloss = data.ProfitLossForPeriod
      this.profitloss = data.ProfitLossOnOrdinaryActivitiesAfterTax //Ticket #39480 on 15/04/2026
      this.Dividends = data.FinalDividendsPaid
      this.profitform.controls['ProfitForYear'].setValue(this.profitloss);
      this.profitform.controls['EquityDividendsPaid'].setValue(this.Dividends);
    })
  }
  count:number=1
  save1() {
    debugger
    if (this.profitform.controls['ReservesAsAt'].value == "" || this.profitform.controls['ReservesAsAt'].value == null||this.profitform.controls['ReservesAsAt'].value == "0") {
      //this.insertprofit();
    } else if (this.profitform.controls['RetainedProfitAt'].value != this.reservedvalue) {
      Swal.fire({
        title: "Andica Accounts Production",
        text: "Retained profits at " + this.commonService.EndDate + " must tally with the Capital and Reserves - Profit and Loss account value in the Balance Sheet for the year " + this.commonService.StartYear + ".",
        icon: "warning",
        confirmButtonText: "OK",
      }).then((result) => {
        //this.insertprofit();
      })
    } else {
      //this.NormalRoutng = false;
      //this.insertprofit();
      return false;
    }
  }

  getBalanceSheetData(APPeriodId) {
    //debugger
    //if (this.commonService.AccountTemplateId) {

    //  this.balanceSheetService.getBalanceSheetFRS101(APPeriodId).subscribe((data: any) => {
    //    this.reserveddata = data;
    //    this.reservedvalue = data.SharePremium
    //    // this.profitform.controls['ReservesAsAt'].setValue(this.reservedvalue);
    //    this.getprofit(this.APPeriodId);
    //  })
    //} else {

      this.balanceSheetService.getBalanceSheet(APPeriodId).subscribe((data: any) => {
        this.reserveddata = data;
        this.reservedvalue = data.ProfitAndLossAccount
        // this.profitform.controls['ReservesAsAt'].setValue(this.reservedvalue);
        this.getprofit(this.APPeriodId);
      })
    //}
  }

  getprofit(APPeriodId) {
    debugger
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.reserveservice.getreserveprofit(this.APPeriodId).subscribe((data: any) => {
      if (data) {
        this.profitform.patchValue(data);
        this.calculation();
        this.profitform.controls['ProfitForYear'].setValue(this.profitloss);
        this.profitform.controls['ProfitForYear'].disable();
        this.profitform.controls['EquityDividendsPaid'].setValue(this.Dividends);
        this.calculation();
        //this.profitform.controls['EquityDividendsPaid'].disable();
      }
      this.commonService.getNotesData();
    })
  }

  getlastyearprofit() {
    this.reserveservice.getreserveprofitLY(this.APPeriodId).subscribe((data: any) => {
      this.showBubbledata = data;
    })
  }
  back() {
    this.profitform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Reserves / Retained profit", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  calculation() {
    debugger;
    var total = parseFloat(((this.profitform.controls['ReservesAsAt'].value == "" || this.profitform.controls['ReservesAsAt'].value == null) ? 0 : this.profitform.controls['ReservesAsAt'].value))
      + parseFloat(((this.profitform.controls['ProfitForYear'].value == "" || this.profitform.controls['ProfitForYear'].value == null) ? 0 : this.profitform.controls['ProfitForYear'].value))
      - parseFloat(((this.profitform.controls['EquityDividendsPaid'].value == "" || this.profitform.controls['EquityDividendsPaid'].value == null) ? 0 : this.profitform.controls['EquityDividendsPaid'].value))
    this.profitform.controls["RetainedProfitAt"].setValue(total);
    this.profitform.controls["RetainedProfitAt"].disable();
    
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.profitform.dirty && this.count !=2) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight: 900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          debugger;
          this.NormalRoutng = true;
          this.count=2
          if (this.save()) {
            return true;
          }
          else if (!this.NormalRoutng)
            return false;
          else if (this.count == 2)
            return false;
        }
        else {
          return true;
        }
      })
    }
    else  {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }


}
